import { postBriefFormReq, postBriefFormAssetReq, getBriefForm } from "api/briefForm";
import { BriefingFormModel } from "pages/BriefingForm/interfaces";
import { call, put } from "redux-saga/effects";
import { resetApiError, riseError } from "../general";
import {
    uploadBriefFormAsset,
    submitBriefForm,
    removeBriefFormAsset,
    fetchBriefForm,
    uploadBriefFormAdditionalAssets,
} from "./briefForm.actions";
import { deleteAssetReq } from "api/assets";

export function* uploadBriefFormAssetSaga(
    headers: HeadersInit,
    action: ReturnType<typeof uploadBriefFormAsset.request>
): Generator {
    try {
        if (!action.payload.file || action.payload.modifiedAssetIndex === undefined) {
            // TODO: Fix this to handle exception correctly
            throw new Error("File and/or index not provided!");
        }

        const formData = new FormData();
        formData.append("matspec", action.payload.materialSpecificationId.toString());
        formData.append("file", action.payload.file);
        const [asset] = (yield call(postBriefFormAssetReq, headers, formData)) as Array<{ id: number }>;
        yield put(
            uploadBriefFormAsset.success({
                id: asset.id,
                fileName: action.payload.file.name,
                index: action.payload.modifiedAssetIndex,
            })
        );
    } catch (err) {
        if (err.status) {
            yield put(uploadBriefFormAsset.failure({ statusCode: err.status }));
            yield put(resetApiError());

            return;
        }

        yield put(riseError(err));
    }
}

export function* uploadBriefFormAdditionalAssetsSaga(
    headers: HeadersInit,
    action: ReturnType<typeof uploadBriefFormAdditionalAssets.request>
): Generator {
    try {
        const formData = new FormData();
        formData.append("matspec", action.payload.materialSpecificationId.toString());
        action.payload.files.forEach((file) => {
            formData.append("file", file);
        });

        const assets = (yield call(postBriefFormAssetReq, headers, formData)) as Array<{ id: number; name: string }>;
        yield put(
            uploadBriefFormAdditionalAssets.success([
                ...assets.map((asset) => ({ id: asset.id, fileName: asset.name })),
            ])
        );
    } catch (err) {
        if (err.status) {
            yield put(uploadBriefFormAdditionalAssets.failure({ statusCode: err.status }));
            yield put(resetApiError());

            return;
        }

        yield put(riseError(err));
    }
}

export function* removeBriefFormAssetSaga(
    headers: HeadersInit,
    { payload: { assetId, removeFromArray } }: ReturnType<typeof removeBriefFormAsset.request>
): Generator {
    try {
        if (assetId === undefined) {
            // TODO: Fix this to handle exception correctly
            throw new Error("Id of an asset to remove is not provided!");
        }

        const id = (yield call(deleteAssetReq, headers, assetId)) as number;
        yield put(removeBriefFormAsset.success({ id, removeFromArray }));
    } catch (err) {
        if (err.status) {
            yield put(uploadBriefFormAsset.failure({ statusCode: err.status }));
            yield put(resetApiError());

            return;
        }

        yield put(riseError(err));
    }
}

export function* fetchBriefFormSaga(
    headers: HeadersInit,
    action: ReturnType<typeof fetchBriefForm.request>
): Generator {
    const { materialSpecificationId } = action.payload;
    try {
        const briefForm = (yield call(getBriefForm, headers, materialSpecificationId)) as BriefingFormModel;
        yield put(fetchBriefForm.success(briefForm));
    } catch (err) {
        if (err.status) {
            yield put(uploadBriefFormAsset.failure({ statusCode: err.status }));
            yield put(resetApiError());

            return;
        }

        yield put(riseError(err));
    }
}

export function* submitBriefFormSaga(
    headers: HeadersInit,
    action: ReturnType<typeof submitBriefForm.request>
): Generator {
    try {
        yield call(postBriefFormReq, headers, action.payload);
        yield put(submitBriefForm.success());
    } catch (err) {
        if (err.status) {
            yield put(uploadBriefFormAsset.failure({ statusCode: err.status }));
            yield put(resetApiError());

            return;
        }

        yield put(riseError(err));
    }
}
